
import "mmenu-light";
import "mmenu-light/src/mmenu-light.scss";

export function initMobileMenu() {
    
    let elem = document.querySelector("#mobile-menu");

    const menu = new MmenuLight(elem, "(max-width: 750px)");
  
    const navigator = menu.navigation();
    const drawer = menu.offcanvas();

    document.querySelector('a[href="#my-menu"]').addEventListener('click', (evnt) => {
        evnt.preventDefault();
        drawer.open();
    });
}
